export default __webpack_public_path__ + "static/media/Cream.703906ee.jpg";